import { getChildByType } from "react-nanny";
import { Slot } from "../../../components/layouts/slot";

const Header = Slot();
const Content = Slot();

const Container = (props: { children: React.ReactNode }) => {
  const header = props.children ? getChildByType(props.children, Header) : null;
  const content = props.children
    ? getChildByType(props.children, Content)
    : null;

  return (
    <main className="relative grid grid-rows-[70px] w-screen h-screen bg-offwhiteVariant overflow-hidden">
      {header}
      {content}
    </main>
  );
};

export const NoSidebar = {
  Container,
  Header,
  Content,
};
